import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import classNames from 'classnames';

import { DragIcon } from '../../../../assets';
import { Checkbox } from '../../../Checkbox';
import { Typography } from '../../../Typography';
import { TColumnSettingsItem } from './useColumnSettingsDraft';

import styles from './TableColumnSettings.module.scss';

export interface IColumnSettingsItemProps {
    item: TColumnSettingsItem;
    locked: boolean;
    onToggle: (id: string) => void;
}

export const ColumnSettingsItem: React.FC<IColumnSettingsItemProps> = ({ item, locked, onToggle }) => {
    const { t } = useTranslation(undefined, { keyPrefix: 'table.columnSettings' });
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
        id: item.id,
    });
    const checkboxId = `column-settings-${item.id}`;

    return (
        <li
            ref={setNodeRef}
            className={classNames(styles.item, { [styles.dragging]: isDragging })}
            style={{ transform: CSS.Transform.toString(transform), transition }}
        >
            <button
                ref={setActivatorNodeRef}
                aria-label={t('dragHandle', { column: item.label })}
                className={styles.dragHandle}
                type="button"
                {...attributes}
                {...listeners}
            >
                <DragIcon />
            </button>
            <Checkbox
                checked={item.visible}
                disabled={locked}
                id={checkboxId}
                onCheckedChange={() => onToggle(item.id)}
            />
            <Typography
                className={styles.label}
                color={item.visible ? 'black' : 'placeholder'}
                component="label"
                cursor="pointer"
                htmlFor={checkboxId}
            >
                {item.label}
            </Typography>
        </li>
    );
};
